import type { HTMLAttributes } from "react";

import { containerStyles } from "./container.styles";
import { cn } from "../../lib/cn";

export type ContainerProps = {
  className?: string;
} & Omit<HTMLAttributes<HTMLDivElement>, "content">;

const Container = ({ className, ...props }: ContainerProps) => {
  return <div className={cn(containerStyles(), className)} {...props} />;
};

export { Container };
